<section>
  <h3>Link to this page</h3>
  <ngx-skeleton-loader *ngIf="isLoading" count="1" [theme]="linkSkeletonTheme" animation="progress" aria-label="Loading page link"></ngx-skeleton-loader>
  <div
    *ngIf="!isLoading"
    class="registration-link-container"
    (click)="copyCode()"
    [ngClass]="{ 'show-status': formLinkStatus }"
    [attr.status]="formLinkStatus"
    [title]="formLink"
  >
    {{ formLink }}
  </div>
  <h3>Raw form (Minimal registration form)</h3>
  <ngx-skeleton-loader *ngIf="isLoading" count="1" [theme]="linkSkeletonTheme" animation="progress" aria-label="Loading raw form link"></ngx-skeleton-loader>
  <div
    *ngIf="!isLoading"
    class="registration-link-container"
    (click)="copyCode(rawFormLink)"
    [ngClass]="{ 'show-status': rawFormLinkStatus }"
    [attr.status]="rawFormLinkStatus"
    [title]="rawFormLink"
  >
    {{ rawFormLink }}
  </div>
  <h3>Trackable mirrors</h3>
  <ng-container *ngIf="isLoading; else mirrorsContent">
    <ngx-skeleton-loader count="2" [theme]="mirrorSkeletonTheme" animation="progress" aria-label="Loading trackable mirrors"></ngx-skeleton-loader>
  </ng-container>
  <ng-template #mirrorsContent>
    <div class="mirrors">
      <form [formGroup]="mirrorForm">
        <div formArrayName="mirrors">
          <div class="mirror" *ngFor="let mirror of mirrorForm.controls['mirrors']['controls']; let i = index">
            <div [ngClass]="{ 'show-status': mirrorLinkStatus[i] }" [attr.status]="mirrorLinkStatus[i]">
              <input #mirrorInput type="text" [value]="mirror.value" [formControl]="mirror" (blur)="saveMirrorValue(i)" (keydown.enter)="addMirror($event, i)" />
            </div>
            <div class="tw-flex tw-items-center tw-gap-2">
              <button mat-icon-button (click)="copyMirror(i)" [disabled]="!mirror.value" ngxTippy="Copy link">
                <img src="https://library.micetribe.com/icons/copy.svg" alt="link" class="tw-w-4 tw-h-4" />
              </button>
              <app-dropdown
                class="tw-w-4 tw-h-4"
                [dropdownOptions]="qrFormatOptions"
                [widthInPX]="'180px'"
                [minWidthInPX]="'180px'"
                [heightInPX]="100"
                [maxHeightInPX]="100"
                (optionClicked)="onQrFormatSelected(i, $event)"
              >
                <button class="qr-btn" mat-icon-button [disabled]="!mirror.value" ngxTippy="Download QR">
                  <img src="https://library.micetribe.com/icons/qr.svg" alt="qr-link" />
                </button>
              </app-dropdown>
              <button mat-icon-button (click)="deleteMirror(i)" [disabled]="mirrorForm.controls['mirrors']['controls'].length === 1">
                <img class="delete tw-w-4 tw-h-4" src="https://library.micetribe.com/icons/delete.svg" alt="delete" />
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <a class="add-mirror-link" (click)="addMirror()">Add mirror</a>
  </ng-template>
</section>
